import { showToast } from "@/providers/ToastProvider";

export function showCosignatureToast({
  isCosignatureRequired,
  providerName,
}: {
  isCosignatureRequired: boolean;
  providerName: string;
}) {
  showToast([
    {
      heading: isCosignatureRequired
        ? `Co-signature now required for ${providerName}. New notes will be routed to supervisors.`
        : `Co-signature no longer required for ${providerName}. New notes will be finalized on signing.`,
      variant: "success",
    },
    { delay: 500 },
  ]);
}
